import { render, staticRenderFns } from "./ReportPromoSuperAdmin.vue?vue&type=template&id=8170420c"
import script from "./ReportPromoSuperAdmin.vue?vue&type=script&lang=js"
export * from "./ReportPromoSuperAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports